import { connect } from 'react-redux'

import { getBasketDate, getBasketOrderId, getNumPortions } from 'selectors/basket'

import { BoxSummaryContent } from './BoxSummaryContent'

function mapStateToProps(state) {
  return {
    date: getBasketDate(state),
    orderId: getBasketOrderId(state),
    numPortions: getNumPortions(state),
  }
}

const BoxSummaryContentContainer = connect(mapStateToProps)(BoxSummaryContent)

export { BoxSummaryContentContainer }
